import EmptyState from "../EmptyState";

export default function DashboardSectionEmpty({ icon, title, description, compact = false }) {
  return (
    <EmptyState
      icon={icon}
      title={title}
      description={description}
      className={compact ? "py-8 px-4 bg-slate-50/80" : ""}
    />
  );
}
